import FileSaver from 'file-saver'

export default {
  export (Name, Columns, Data) {
    return new Promise((resolve, reject) => {
      try {
        let result = []
        Data.forEach(item => {
          let data = {}
          Columns.forEach(col => {
            if (typeof col.template === 'function') {
              data[col.field] = col.template(item)
            } else {
              data[col.field] = item[col.field] || ''
            }
          })
          return result.push(data)
        })
        // create dara rows
        this.generateAndSave(JSON.stringify(result, null, 2), Name)
        resolve('done')
      } catch (e) {
        throw new Error(e)
      }
    })
  },
  generateAndSave (String, Name) {
    /* send to client */
    FileSaver.saveAs(new Blob([String], { type: 'application/json;charset=utf-8' }), Name + '.json')
  }

}
